/**
 * All unprotected parameter
 */
export enum UnprotectedParameterEnum {
  ADDRESSBOOK = 'ADDRESSBOOK',
  TICKET_SEARCH_MAX_RESULTS = 'TICKET_SEARCH_MAX_RESULTS',
  CLOUD_EXPORT_ALLOW_ASYNC = 'CLOUD_EXPORT_ALLOW_ASYNC',
  CLOUD_EXPORT_ALLOW_SYNC = 'CLOUD_EXPORT_ALLOW_SYNC',
  CASE_ACTION_COMMENT_SETTING = 'CASE_ACTION_COMMENT_SETTING',
  USE_AUDIT_FEATURE = 'USE_AUDIT_FEATURE',
  USE_MCR_FEATURE = 'USE_MCR_FEATURE',
  TRANSFERT_MODE = 'TRANSFERT_MODE',
  TRANSFER_INTERSPACE = 'TRANSFER_INTERSPACE',
  CUSTOMER_EXTERNAL_REFERENCE_URL = 'CUSTOMER_EXTERNAL_REFERENCE_URL',
  TICKET_COMMENT_WHEN = 'TICKET_COMMENT_WHEN',
  TICKET_COMMENT_WHO = 'TICKET_COMMENT_WHO',
  TICKET_UPDATE_FIELDS_WHEN = 'TICKET_UPDATE_FIELDS_WHEN',
  TICKET_UPDATE_FIELDS_WHO = 'TICKET_UPDATE_FIELDS_WHO',
  TICKET_ATTACHMENT_WHEN = 'TICKET_ATTACHMENT_WHEN',
  TICKET_ATTACHMENT_WHO = 'TICKET_ATTACHMENT_WHO',
  TICKET_TYPOLOGY_FILTERBY_USERSKILLS = 'TICKET_TYPOLOGY_FILTERBY_USERSKILLS',
  TICKET_TYPOLOGY_SKILL_RELATION = 'TICKET_TYPOLOGY_SKILL_RELATION',
}

/**
 * Instance Parameter interface
 */
export interface InstanceParameterDTOV1 {
  code: UnprotectedParameterEnum
  name: string
  description: string
  value: string
}

export enum TransfertModeEnum {
  ALL = 'ALL',
  CUSTOM = 'CUSTOM',
}

export enum CaseActionCommentModeEnum {
  NONE = 'NONE',
  OPTIONAL = 'OPTIONAL',
  REQUIRED = 'REQUIRED',
}

export enum TicketEditWhoEnum {
  TICKET_OWNER = 'TICKET_OWNER',
  TICKET_OWNER_AND_SUPERUSERS_WITH_SKILL = 'TICKET_OWNER_AND_SUPERUSERS_WITH_SKILL',
  USERS_WITH_SKILL = 'USERS_WITH_SKILL',
  USERS_WITH_SKILL_AND_ACCESS_RIGHT = 'USERS_WITH_SKILL_AND_ACCESS_RIGHT',
  ALL_USERS = 'ALL_USERS',
}

export enum TicketEditWhenEnum {
  OPEN_AND_CLOSED_TICKET = 'OPEN_AND_CLOSED_TICKET',
  OPEN_TICKET = 'OPEN_TICKET',
}

export enum TypologySkillRelationEnum {
  REQUIRED = 'REQUIRED',
  OPTIONAL = 'OPTIONAL',
  NONE = 'NONE',
}
